import { render, staticRenderFns } from "./YpQuillEditor.vue?vue&type=template&id=67b1e270&scoped=true&"
import script from "./YpQuillEditor.vue?vue&type=script&lang=js&"
export * from "./YpQuillEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b1e270",
  null
  
)

export default component.exports